<template>
  <Map />
</template>

<script>
import Map from '@/components/organisms/Map'

export default {
  components: {
    Map
  },
}
</script>